import axios from 'axios';
import { logout, notFound } from './auth';
import store from '../store';

const axiosInstance = axios.create();
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response ? error.response.status : null;
    if (status === 401) {
      console.log("401 error --------------------------------------");
      // Dispatch the logout action to clear the user's session
      store.dispatch(logout("Session Expired. Please login again."));
    }
    if (status === 403) {
      console.log("403 error --------------------------------------");
      // Dispatch the logout action to clear the user's session
      store.dispatch(logout());
    }
    if (status === 404) {
      console.log("404 error --------------------------------------");
      // Dispatch the logout action to clear the user's session
      store.dispatch(notFound());
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;